import { useCallback, useEffect, useState } from "react";
import { Plus, Pencil, Trash2, Megaphone } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { ArticleFormDialog } from "@/components/admin/ArticleFormDialog";
import { ConfirmDelete } from "@/components/admin/ConfirmDelete";

export default function Articles() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState({ open: false, article: null });
  const [del, setDel] = useState(null);
  const load = useCallback(() => { api.get("/admin/articles").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  useEffect(load, [load]);

  const remove = async () => {
    try { await api.delete(`/admin/articles/${del.id}`); toast.success("Communiqué supprimé"); load(); } catch (e) { toast.error(errMsg(e)); }
    setDel(null);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Communiqués</h1>
          <p className="text-slate-500 mt-1">Informations visibles par les visiteurs du site.</p>
        </div>
        <Button onClick={() => setEdit({ open: true, article: null })} data-testid="article-add-button" className="rounded-full"><Plus className="h-4 w-4 mr-1" /> Nouveau communiqué</Button>
      </div>
      <div className="space-y-3">
        {items.map((a) => (
          <div key={a.id} data-testid={`admin-article-${a.id}`} className="flex items-center gap-4 rounded-2xl border border-emerald-900/10 bg-white p-3 sm:p-4">
            <div className="h-16 w-24 rounded-lg bg-emerald-50 overflow-hidden grid place-items-center shrink-0">
              {a.image ? <img src={fileUrl(a.image)} alt="" className="h-full w-full object-cover" /> : <Megaphone className="h-6 w-6 text-emerald-700/40" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-slate-900 truncate">{a.titre}</div>
              <div className="text-xs text-slate-500 mt-1 flex flex-wrap gap-2 items-center">
                <span>{fmtDate(a.created_at)}</span>
                <span className={`rounded-full px-2 py-0.5 border ${a.publie ? "border-emerald-300 text-emerald-800 bg-emerald-50" : "border-slate-300 text-slate-600"}`}>{a.publie ? "Publié" : "Brouillon"}</span>
              </div>
            </div>
            <Button size="icon" variant="ghost" onClick={() => setEdit({ open: true, article: a })} data-testid={`article-edit-${a.id}`}><Pencil className="h-4 w-4" /></Button>
            <Button size="icon" variant="ghost" onClick={() => setDel(a)} data-testid={`article-delete-${a.id}`} className="text-rose-600"><Trash2 className="h-4 w-4" /></Button>
          </div>
        ))}
        {!items.length && <p data-testid="admin-articles-empty" className="text-slate-500 py-8">Aucun communiqué.</p>}
      </div>
      <ArticleFormDialog open={edit.open} article={edit.article} onOpenChange={(o) => setEdit((s) => ({ ...s, open: o }))} onSaved={load} />
      <ConfirmDelete open={!!del} onOpenChange={(o) => !o && setDel(null)} onConfirm={remove} title="Supprimer ce communiqué ?" description={del?.titre || ""} />
    </div>
  );
}
